class LocationDrawers extends HTMLElement {
  constructor() {
    super();

    this.location = document.querySelector('.location-wrapper');
    this.accordion = this.querySelector('.prd-accordion');

    this.waitForElements(['.page-width', '.iia-id-65693515965', '.iia-id-65693515965 .iia-note'], () => {
      this.initialiseLocationDrawers();
    });
  }

  waitForElements(selectors, callback) {
    const allExist = () => selectors.every(sel => document.querySelector(sel));

    if (allExist()) {
      callback();
      return;
    }

    const observer = new MutationObserver(() => {
      if (allExist()) {
        observer.disconnect();
        callback();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  initialiseLocationDrawers() {
    const locationWidthWrapper = document.querySelector('.page-width');
    const note = document.querySelector('.iia-id-65693515965 .iia-note');
    const item = document.querySelector('.iia-id-65693515965');

    if (!locationWidthWrapper || !note || !item) return;

    // Hide location app
    locationWidthWrapper.style.display = 'none';

    // Show drawer and move content
    this.accordion.classList.remove('prd-accordion--hidden');
    this.location.appendChild(locationWidthWrapper);
    item.insertAdjacentElement('beforeend', note);
    locationWidthWrapper.style.display = 'block';
  }
}

customElements.define('location-drawers', LocationDrawers);